// @ts-nocheck
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import constants from "@store/constants";
import { TECertificateStateContext } from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesSelectors";
import React, { useContext } from "react";

export interface ContactFormStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
    loadingOverlay?: LoadingOverlayProps;
    container?: GridContainerProps;
    formGridItem?: GridItemProps;
}

export const contactFormStyles: ContactFormStyles = {
    formGridItem: {
        width: 12,
    },
};

const styles = contactFormStyles;

const TECContactSupportFormContainer = ({ id }: WidgetProps) => {
    const certificateDataView = useContext(TECertificateStateContext);

    return (
        <PageErrorWrapper
            value={certificateDataView}
            badRequestMessage={siteMessage("TECContactSupport_BadRequest")}
            notAuthorizedMessage={siteMessage("TECContactSupport_NotAuthorized")}
            notFoundMessage={siteMessage("TECContactSupport_NotFound")}
            extendedStyles={styles.pageErrorWrapper}
        >
            <DataViewLoadingOverlay dataView={certificateDataView} {...styles.loadingOverlay}>
                <GridContainer {...styles.container}>
                    <GridItem {...styles.formGridItem}>
                        <Zone contentId={id} zoneName="Content" />
                    </GridItem>
                </GridContainer>
            </DataViewLoadingOverlay>
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: TECContactSupportFormContainer,
    definition: {
        group: constants.widgetGroup.tecContactSupport,
        allowedContexts: ["TECContactSupportPage" as any],
        icon: "input-pipe",
    },
};

export default widgetModule;
